import * as actionTypes from '../actions/actionTypes';

const initialState = {
    error: false,
    lowestFare: []
}

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.SET_LOWEST_FARE:
            return {
                ...state,
                lowestFare: action.lowestFare
            }
        case actionTypes.GET_LOWEST_FARE_FAILED:
            return {
                error: true
            }
        default:
            return state;
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/lowestFare.js